import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Input from '@material-ui/core/Input';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Snackbar, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Countdown from 'react-countdown-now';
import URL from '../constants/url';
import InputMask from 'react-input-mask';
const axios = require('axios');

const styles = theme => ({
  root: {
    width: '90%',
    margin: '0 auto',
    marginTop: '20px'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    color: 'white'
  },
  panelHead: {
    // backgroundColor: #eee"
    background: 'linear-gradient(60deg, #26c6da, #00acc1) ',
    color: 'pink',
    borderRadius: '3px'
  },
  icon: {
    color: 'white !important',
    background: 'white'
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  icon: {
    verticalAlign: 'bottom',
    height: 20,
    width: 20
  },
  shadowed: {
    boxShadow: '0 4px 20px 0px rgba(0, 0, 0, 0.14)',
    boxShadow: '0 7px 10px -5px rgb(5, 111, 124)'
  },
  details: {
    alignItems: 'center',
    height: '100px'
  },
  column: {
    flexBasis: '33.0%'
    // border: "1px solid black"
  },
  numberColumn: {
    // flexBasis: "75%",
    // border: "1px solid black"
    display: 'flex',
    flexWrap: 'nowrap'
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
    // flexBasis: "50%"
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },
  copyBtn: {
    backgroundColor: '#42a5f5',
    marginLeft: '10px',
    marginRight: '5px'
    // display: "block",
    // margin: "0 auto"
  },
  number: {
    // paddingLeft: "10px"
    textAlign: 'center'
  },
  input: {
    width: '80%'
  }
});

// Random component
const Completionist = () => (
  <div style={{ color: '#f1e652', display: 'inline-flex', maxHeight: '10px' }}>
    <i className="material-icons">warning</i>
    <p>{' Number expired!'}</p>
  </div>
);

// Renderer callback with condition
const renderer = ({ hours, minutes, seconds, completed }) => {
  if (completed) {
    // Render a completed state
    return <Completionist />;
  } else {
    // Render a countdown
    return (
      <div
        style={{
          color: 'white',
          border: '1px solid #eee',
          borderRadius: '7px',
          textAlign: 'center',
          padding: '1px 10px'
        }}
      >
        <p style={{ margin: '0 auto' }}>
          {minutes}:{seconds}
        </p>
      </div>
    );
  }
};

class DetailedExpansionPanel extends React.Component {
  /*componentDidUpdate() is invoked immediately after updating occurs.
  This method is not called for the initial render.*/
  // componentWillMount() {
  //   this.setState({
  //     parentState: this.props.parentState
  //   });
  // }

  componentDidUpdate(prev) {
    if (prev.parentState != this.props.parentState) {
      this.setState({
        parentState: this.props.parentState,
        expansionPanelOpen: !!this.props.parentState.selectedNumber
      });
    } else {
      // console.log("same");
    }
  }
  // componentWillReceiveProps(){
  //   console.log("WIILLPROPS",this.props.parentState);
  //   this.setState({
  //     parentState: this.props.parentState
  //   })
  // }

  componentDidMount() {
    // console.log(this.props);

    const interval = setInterval(
      function() {
        if (1 == 0) {
          clearInterval(interval);

          // otherwise do things
        }

        if (
          //Eger UK numarasi seciliyse ve numara alindiysa 10 snyede bir kontrol et mesaj gelmis mi diye
          this.state.parentState.selectedNumber !== '' &&
          this.state.parentState.selectedCountry === 'USA'
        ) {
          this.props.checkUK();
        }
        // console.log(this.state.parentState);
      }.bind(this),
      3000
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      parentState: this.props.parentState,
      snackOpen: false
    };
  }

  handleClose = () => {
    this.setState({ snackOpen: false });
  };
  render() {
    const { classes, theme } = this.props;

    return (
      <div className={classes.root}>
        {/* {console.log(this.state)} */}
        <ExpansionPanel
          // defaultExpanded={true}
          expanded={!!this.state.expansionPanelOpen}
          disabled={!this.state.parentState.selectedNumber}
          className={classes.shadowed}
        >
          <ExpansionPanelSummary
            expandIcon={
              <ExpandMoreIcon
                style={{ color: '#eee' }}
                onClick={() => {
                  if (this.state.parentState.selectedNumber) {
                    this.setState({
                      expansionPanelOpen: !this.state.expansionPanelOpen
                    });
                  }

                  // this.state.parentState.selectedNumber
                  //   ? this.setState({
                  //       expansionPanelOpen: !this.state.expansionPanelOpen
                  //     })
                  //   : null;
                }}
              />
            }
            className={classes.panelHead}
          >
            <div className={classes.column}>
              <Typography className={classes.heading}>Receive SMS</Typography>
            </div>
            {/* <div className={classes.column}> */}
            {this.state.parentState.selectedNumber ? (
              <Countdown
                date={this.state.parentState.expiry * 1000}
                renderer={renderer}
              />
            ) : null}
            {/* </div> */}
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.details}>
            <div className={classes.numberColumn}>
              {/* {console.log("STATE", this.state.parentState)} */}
              <Input
                // defaultValue={"1"}
                // defaultValue={this.state.parentState.selectedNumber}
                value={this.state.parentState.selectedNumber}
                className={classes.input}
                inputProps={{
                  'aria-label': 'Description'
                }}
              >
                {/* <InputMask mask="(0)999 999 99 99" maskChar=" " /> */}
              </Input>

              <CopyToClipboard text={this.state.parentState.selectedNumber}>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.copyBtn}
                  onClick={() => {
                    this.setState({ snackOpen: true });
                  }}
                >
                  Copy
                </Button>
              </CopyToClipboard>
              <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                open={this.state.snackOpen}
                onClose={this.handleClose}
                ContentProps={{
                  'aria-describedby': 'message-id'
                }}
                message={
                  <span id="message-id">
                    Copied: {this.state.parentState.selectedNumber}
                  </span>
                }
                action={[
                  <IconButton
                    key="close"
                    aria-label="Close"
                    color="inherit"
                    className={classes.close}
                    onClick={this.handleClose}
                  >
                    <CloseIcon />
                  </IconButton>
                ]}
              />
            </div>
            {/* <div className={classes.column} /> */}
            <div className={classNames(classes.column, classes.helper)}>
              <Typography variant="caption">
                Use this number to receive sms from{' '}
                {this.state.parentState.selected}
                <br />
                <a href="#sub-labels-and-columns" className={classes.link}>
                  Learn more
                </a>
              </Typography>
            </div>
          </ExpansionPanelDetails>
          {/* {console.log(this.state)} */}
          <Divider />
          <ExpansionPanelActions>
            <Button
              size="small"
              style={{ border: '0 solid #bf6767db', color: '#c14343' }}
              onClick={
                // this.props.setLoaderState(true);

                // let cancelQuery = {};
                // cancelQuery["number"] = this.state.parentState.selectedNumber;
                // cancelQuery["uid"] = this.props.user;
                // cancelQuery["service"] = this.state.parentState.selected;

                this.props.parentSkip
              }
            >
              Skip Number?
            </Button>
            <Button
              size="small"
              onClick={() => {
                this.props.setLoaderState(true);
                // console.log("cancel clicked");
                // console.log(this.props);
                // this.props.parentDestroy();
                let cancelQuery = {};
                cancelQuery['number'] = this.state.parentState.selectedNumber;
                cancelQuery['uid'] = this.props.user;
                cancelQuery['service'] = this.state.parentState.selected;

                axios.post(URL + '/cancel', cancelQuery).then(response => {
                  if (
                    response.data.success === true ||
                    response.data.success === 'done'
                  ) {
                    this.props.parentDestroy();
                  } else {
                    console.log(response.data);
                  }
                  this.props.setLoaderState(false);
                });
              }}
            >
              Cancel Order
            </Button>
            <Button
              size="small"
              color="primary"
              onClick={() => {
                this.props.setLoaderState(true);
                // console.log("cancel clicked");
                // console.log(this.props);
                // this.props.parentDestroy();
                let cancelQuery = {};
                cancelQuery['number'] = this.state.parentState.selectedNumber;
                cancelQuery['uid'] = this.props.user;
                cancelQuery['service'] = this.state.parentState.selected;

                axios.post(URL + '/cancel', cancelQuery).then(response => {
                  if (
                    response.data.success === true ||
                    response.data.success === 'done'
                  ) {
                    this.props.parentDestroy();
                  } else {
                    console.log(response.data);
                  }
                  this.props.setLoaderState(false);
                });
              }}
            >
              Done
            </Button>
          </ExpansionPanelActions>
        </ExpansionPanel>
      </div>
    );
  }
}

// function DetailedExpansionPanel(props) {
//   const { classes } = props;
//   //   {console.log(props);}
//   // componentWillReceiveProps(nextProps) {
//   //   this.setState({ data: nextProps.data });
//   // }

// }

DetailedExpansionPanel.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(DetailedExpansionPanel);
